import { Mapper } from './mapper';

export const TipoRegimePrevidenciario = Mapper.from([
  [1, 'Regime Geral de Previdência Social - RGPS'],
  [2, 'Regime Próprio de Previdência Social - RPPS'],
  [3, 'Regime de Previdência Social no exterior'],
]);
